import { c as _c } from "react/compiler-runtime";
import { ApiDrop } from "@/generated/models/ApiDrop";
import { getThemeColors } from "./ParticipationDropRatingsTheme";
import { RatingsData } from "./types";
import ParticipationDropRatingsTotalSection from "./ParticipationDropRatingsTotalSection";
import ParticipationDropRatingsVoterSection from "./ParticipationDropRatingsVoterSection";
import ParticipationDropRatingsUserSection from "./ParticipationDropRatingsUserSection";
interface ParticipationDropRatingsContainerProps {
  readonly drop: ApiDrop;
  readonly rank?: number | null | undefined;
}
export default function ParticipationDropRatingsContainer(t0) {
  const $ = _c(24);
  const {
    drop,
    rank: t1
  } = t0;
  const rank = t1 === undefined ? null : t1;
  const t2 = drop.top_raters && drop.top_raters.length > 0;
  const t3 = drop.context_profile_context?.rating ?? 0;
  const t4 = drop.rating ?? 0;
  let t5;
  if ($[0] !== t2 || $[1] !== t3 || $[2] !== t4) {
    t5 = {
      hasRaters: t2,
      userRating: t3,
      currentRating: t4
    };
    $[0] = t2;
    $[1] = t3;
    $[2] = t4;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const ratingsData = t5;
  const t6 = ratingsData.currentRating < 0;
  let t7;
  if ($[4] !== rank || $[5] !== t6) {
    t7 = getThemeColors(rank, t6);
    $[4] = rank;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const theme = t7;
  const t8 = ratingsData.userRating < 0;
  let t9;
  if ($[7] !== rank || $[8] !== t8) {
    t9 = getThemeColors(rank, t8);
    $[7] = rank;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  const userTheme = t9;
  let t10;
  if ($[10] !== drop || $[11] !== rank || $[12] !== ratingsData || $[13] !== theme) {
    t10 = <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-x-6 tw-gap-y-2"><ParticipationDropRatingsTotalSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} /><ParticipationDropRatingsVoterSection drop={drop} rank={rank} theme={theme} ratingsData={ratingsData} /></div>;
    $[10] = drop;
    $[11] = rank;
    $[12] = ratingsData;
    $[13] = theme;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== drop || $[16] !== rank || $[17] !== ratingsData || $[18] !== theme || $[19] !== userTheme) {
    t11 = <ParticipationDropRatingsUserSection drop={drop} rank={rank} theme={theme} userTheme={userTheme} ratingsData={ratingsData} />;
    $[15] = drop;
    $[16] = rank;
    $[17] = ratingsData;
    $[18] = theme;
    $[19] = userTheme;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t10 || $[22] !== t11) {
    t12 = <div className="tw-flex tw-items-center tw-flex-wrap tw-gap-y-2 tw-gap-x-6">{t10}{t11}</div>;
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}